import React, { useState, useEffect, useContext } from "react";
import { AxiosContext } from "../AxiosContext";

type Option = {
  value: string;
  label: string;
};

export const SuburbAutocomplete = () => {

  const { publicAxios } = useContext(AxiosContext);

  const [query, setQuery] = useState("");
  const [options, setOptions] = useState<Option[]>([]);
  const [selected, setSelected] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);

  // Fetch options
  useEffect(() => {
    if (!query) {
      setOptions([]);
      return;
    }

    const fetchOptions = async () => {
      setLoading(true);
      try {
        const res = await publicAxios.get(`/v1/suburb/suggestion?search=${query}`);
        setOptions(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    const timeout = setTimeout(fetchOptions, 300); // debounce
    return () => clearTimeout(timeout);
  }, [query]);

  // Add suburb
  const addSuburb = (opt: Option) => {
    if (!selected.find((s) => s.value === opt.value)) {
      setSelected([...selected, opt]);
    }
    setQuery("");
    setOptions([]);
  };

  // Remove suburb
  const removeSuburb = (val: string) => {
    setSelected(selected.filter((s) => s.value !== val));
  };

  return (
    <div className="w-full max-w-lg">
      {/* Selected tags */}
      <div className="flex flex-wrap gap-2 mb-2">
        {selected.map((s) => (
          <span
            key={s.value}
            className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full flex items-center gap-2"
          >
            {s.label}
            <button
              onClick={() => removeSuburb(s.value)}
              className="text-purple-500 hover:text-purple-800"
            >
              ✕
            </button>
          </span>
        ))}
      </div>

      {/* Input */}
      <div className="relative">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search suburb..."
          className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
        />

        {/* Dropdown */}
        {query && options.length > 0 && (
          <ul className="absolute w-full bg-white border rounded-lg shadow-md mt-1 max-h-60 overflow-y-auto z-10">
            {options.map((opt) => (
              <li
                key={opt.value}
                onClick={() => addSuburb(opt)}
                className="px-3 py-2 hover:bg-purple-100 cursor-pointer"
              >
                {opt.label}
              </li>
            ))}
          </ul>
        )}

        {/* Loading state */}
        {loading && (
          <div className="absolute right-3 top-2 text-sm text-gray-400">
            Loading...
          </div>
        )}
      </div>
    </div>
  );
}
